import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'app/shared/shared.module';
import { NgxPaginationModule } from 'ngx-pagination';
import { AddCreditToCompanyComponent } from './add-credit-to-company/add-credit-to-company.component';
import {
  FinancialTransactionsListComponent
} from './financial-transactions-list/financial-transactions-list.component';
import { FinancialTransactionsRoutingModule } from './financial-transactions-routing.module';
import {
  FinancialTransactionDetailsComponent
} from './financial-transaction-details/financial-transaction-details.component';
import {
  FinancialTransactionsExportComponent
} from './financial-transactions-export/financial-transactions-export.component';

@NgModule({
  imports: [
    CommonModule,
    FinancialTransactionsRoutingModule,
    NgxPaginationModule,
    SharedModule
  ],
  declarations: [
    FinancialTransactionsListComponent,
    AddCreditToCompanyComponent,
    FinancialTransactionDetailsComponent,
    FinancialTransactionsExportComponent
  ],
  entryComponents: [
    AddCreditToCompanyComponent,
    FinancialTransactionDetailsComponent,
    FinancialTransactionsExportComponent
  ]
})
export class FinancialTransactionsModule {
}
